import React, { useEffect, useState } from 'react';

import { usePolicyChecks } from '../../update/hooks/usePolicyChecks';
import { GENERIC_ERROR_MESSAGE, POLICY_CHANGED_MESSAGE } from '../../update/hooks/usePrivacyPolicy';
import { get, jsonPost, makeUrl } from '../../utils/LoginApiUtils';

import PrivacyPolicyView from './PrivacyPolicyView';

const PrivacyPolicyContainer = () => {
    const [info, setInfo] = useState(null);
    const [isAccepting, setIsAccepting] = useState(false);
    const [isDeclining, setIsDeclining] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const returnUrl = window.RETURN_URL;
    const documents = info?.documents || [];
    const checks = usePolicyChecks(info?.email, documents);

    const loadInfo = () =>
        get(makeUrl('PrivacyPolicy', 'Info')).then((res) => {
            const result = res.body;
            if (result && result.success && result.required) {
                setInfo(result);
            } else {
                // Loop-breaker: nothing to accept, so send the user straight back to their
                // original destination instead of showing the page.
                window.location.href = returnUrl;
            }
        });

    useEffect(() => {
        loadInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onAccept = () => {
        setIsAccepting(true);
        setErrorMessage('');
        jsonPost(makeUrl('PrivacyPolicy', 'Accept'), {
            documents: documents.map(({ type, version }) => ({ type, version })),
        })
            .then((res) => {
                const result = res.body;
                if (result && result.success) {
                    checks.reset();
                    window.location.href = returnUrl;
                    return;
                }
                setIsAccepting(false);
                if (result && result.error === 'policy.changed') {
                    setErrorMessage(POLICY_CHANGED_MESSAGE);
                    loadInfo();
                } else {
                    setErrorMessage(GENERIC_ERROR_MESSAGE);
                }
            })
            .catch(() => {
                setIsAccepting(false);
                setErrorMessage(GENERIC_ERROR_MESSAGE);
            });
    };

    const onDecline = () => {
        setIsDeclining(true);
        checks.reset();
        jsonPost(makeUrl('PrivacyPolicy', 'Decline'))
            .then((res) => {
                const result = res.body;
                window.location.href = (result && result.redirectUrl) || '/';
            })
            .catch(() => {
                window.location.href = '/';
            });
    };

    if (!info) return null;

    return (
        <PrivacyPolicyView
            companyName={info.companyName}
            logoUrl={info.logoUrl}
            alternateLogoUrl={info.alternateLogoUrl}
            email={info.email}
            title={info.title}
            text={info.text}
            documents={documents}
            checkedTypes={checks.checkedTypes}
            isAccepting={isAccepting}
            isDeclining={isDeclining}
            errorMessage={errorMessage}
            onCheckedChange={checks.onCheckedChange}
            onAccept={onAccept}
            onDecline={onDecline}
        />
    );
};

export default PrivacyPolicyContainer;
